"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.componentArgs = exports.availableVariants = exports.availableSizes = exports.availableLayouts = exports.variants = exports.sizes = exports.layouts = void 0;
var layouts = Object.freeze({
  HUG: "hug",
  STRETCH: "stretch"
});
exports.layouts = layouts;
var sizes = Object.freeze({
  DEFAULT: "defaultSize",
  DENSE: "dense"
});
exports.sizes = sizes;
var variants = Object.freeze({
  CONTAINED: "contained",
  OUTLINED: "outlined",
  TEXT: "text"
});
exports.variants = variants;
var availableLayouts = Object.freeze(Object.values(layouts));
exports.availableLayouts = availableLayouts;
var availableSizes = Object.freeze(Object.values(sizes));
exports.availableSizes = availableSizes;
var availableVariants = Object.freeze(Object.values(variants));
exports.availableVariants = availableVariants;
var componentArgs = {
  children: {
    description: "The content of the component",
    control: {
      disable: true
    },
    table: {
      type: {
        summary: "node"
      }
    },
    type: {
      required: true
    }
  },
  disabled: {
    defaultValue: false,
    description: "If true, the component is disabled",
    control: {
      type: "boolean"
    },
    table: {
      type: {
        summary: "boolean"
      },
      defaultValue: {
        summary: "false"
      }
    }
  },
  layout: {
    control: {
      type: "select"
    },
    defaultValue: layouts.HUG,
    description: "Which layout option to use",
    options: availableLayouts,
    table: {
      type: {
        summary: "string"
      },
      defaultValue: {
        summary: layouts.HUG
      }
    }
  },
  size: {
    control: {
      type: "select"
    },
    defaultValue: sizes.DEFAULT,
    description: "Which size option to use",
    options: availableSizes,
    table: {
      type: {
        summary: "string"
      },
      defaultValue: {
        summary: sizes.DEFAULT
      }
    }
  },
  variant: {
    control: {
      type: "select"
    },
    defaultValue: variants.CONTAINED,
    description: "Which variant option to use",
    options: availableVariants,
    table: {
      type: {
        summary: "string"
      },
      defaultValue: {
        summary: variants.CONTAINED
      }
    }
  }
};
exports.componentArgs = componentArgs;